const Home = () => (
  <div className="">
    <h1>Welcome to our page!</h1>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit.
      Placeat dolor ratione nulla expedita eligendi error quo corrupti.
      Id cum placeat voluptate totam modi quaerat eveniet voluptatum ab fuga ullam,
      aliquam aliquid officia ad in enim earum aut saepe non sit maiores?
      Officia in explicabo illo similique natus ea voluptatibus eveniet.
    </p>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
      Enim, praesentium. Impedit eveniet tenetur illum fugiat harum hic molestias ipsum explicabo
      exercitationem aspernatur officiis eligendi rerum tempora excepturi nisi debitis voluptate,
      temporibus, in magnam voluptatem autem? Facilis, dolor?
      Provident, tenetur labore. Veniam nobis,
      inventore libero quis tenetur est enim iste nisi!
    </p>
  </div>
);

export default Home;
